import { useDispatch } from 'react-redux';
import { setIsNotFound } from '../redux/actions/layoutAction';

export const useNotFound = () => {
  const dispatch = useDispatch();
  return (isNotFound) => {
    dispatch(setIsNotFound(isNotFound));
  };
};
